<ds-card class="d-flex p-4">
  <form [formGroup]="form" class="d-flex w-100">
    <ds-input
      class="w-100"
      formControlName="promocode"
      [error]="promocodeError"
      placeholder="Enter Code"
      data-id="promocode"
    />
    <p *ngIf="promocodeError" class="d-none" data-id="error">{{ promocodeError }}</p>

    <div class="ml-4">
      <ds-button
        *ngIf="promocode; else applyPromocodeTemplate"
        (click)="remove()"
        variant="secondary"
        label="Remove"
        data-id="remove"
      />

      <ng-template #applyPromocodeTemplate>
        <ds-button
          (click)="submit()"
          [disabled]="loading || form.invalid || form.pristine"
          label="Apply"
          data-id="apply"
        />
      </ng-template>
    </div>
  </form>
</ds-card>
